// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input__21N1H"};